import React from "react";
import { Receipt, defaultReceipt } from "./Receipt";

// Holds the picture-upload state for the current session. The rest of the
// working receipt (items/users/tax/tip) lives in Main's local state and is
// persisted to Firestore on Share.
interface ReceiptContextType {
  receipt: Receipt;
  updateReceipt: (partialReceipt: Partial<Receipt>) => void;
  pictureUploaded: boolean;
  setPictureUploaded: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReceiptContext = React.createContext<ReceiptContextType | undefined>(
  undefined
);

interface ReceiptProviderProps {
  children: React.ReactNode;
}

export const ReceiptProvider: React.FC<ReceiptProviderProps> = ({
  children,
}) => {
  const [receipt, setReceipt] = React.useState<Receipt>({ ...defaultReceipt });
  const [pictureUploaded, setPictureUploaded] = React.useState(false);

  const updateReceipt = (partialReceipt: Partial<Receipt>) => {
    setReceipt((prev) => ({ ...prev, ...partialReceipt }));
  };

  return (
    <ReceiptContext.Provider
      value={{ receipt, updateReceipt, pictureUploaded, setPictureUploaded }}
    >
      {children}
    </ReceiptContext.Provider>
  );
};

export const useReceipt = () => {
  const context = React.useContext(ReceiptContext);
  if (!context) {
    throw new Error("useReceipt must be used within a ReceiptProvider");
  }
  return context;
};
